'use client';
import { useEffect } from 'react';

import annalsAuth from '~features/annals/hooks/auth';
import {
	loadFromSessionStorage,
	saveToSessionStorage,
	ssKeys,
} from '~features/storage';
import { useSession } from '~hooks/useSession';
import { MarkersService } from '~services/markers';

export const useInitialRouteHandle = () => {
	const { userId, isDemoUser } = useSession();

	const annalsDemoVisitor = annalsAuth.useSiteVisitDemoUser();

	useEffect(() => {
		const sent = loadFromSessionStorage(ssKeys.ANNALS_SITE_VISIT_SENT, false);
		if (!isDemoUser || sent) return;

		const markers = MarkersService.getMarkersAnnals();
		annalsDemoVisitor({ ...markers, id: userId });
		saveToSessionStorage(ssKeys.ANNALS_SITE_VISIT_SENT, true);
	}, [annalsDemoVisitor, isDemoUser, userId]);
};

export const InitialRouteHandler = () => {
	useInitialRouteHandle();
	return null;
};
